import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faChevronRight, faUser } from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';

// -- Cadeia de liderança (topo para baixo) --
const chain = [
  {
    name: 'André Valadão',
    role: 'Pastor Geral',
    org: 'Lagoinha Global',
    photo: '/images/pastor_global1.jpg',
    // description: 'Pastor geral da Lagoinha Global — uma rede de quase 700 igrejas espalhadas pelo mundo.',
    badge: 'Global',
    ring: 'ring-yellow-500/50',
    glow: 'bg-yellow-500/15',
    badgeColor: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
    nameColor: 'text-yellow-400',
  },
  {
    name: 'Rafael Barreto e Heloísa Barreto',
    role: 'Pastores Regional',
    org: 'Lagoinha RN|PB',
    photo: '/images/pastor_regional.jpg',
    // description: 'Descrição do pastor regional.',
    badge: 'Regional',
    ring: 'ring-blue-500/40',
    glow: 'bg-blue-500/12',
    badgeColor: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
    nameColor: 'text-blue-400',
  },
  {
    name: 'Renato Dantas e Patricia Rosa',
    role: 'Pastores Sênior',
    org: 'Lagoinha Cidade Verde',
    photo: '/images/pastor_local.jpg',
    // description: 'Descrição do pastor sênior da Lagoinha Cidade Verde.',
    badge: 'Local',
    ring: 'ring-emerald-500/40',
    glow: 'bg-emerald-500/12',
    badgeColor: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
    nameColor: 'text-emerald-400',
  },
];

// -- Pastores auxiliares --
const auxiliares = [
  {
    name: 'Leandro e Rafhaella',
    role: 'Lider do Legacy',
    photo: '/images/pastor_leandro.jpg',
    // description: 'Descrição do pastor auxiliar.',
  },
  {
    name: 'Denis e Célia',
    role: 'Pastor Auxiliar',
    photo: '/images/pastor_denis.png',
    // description: 'Descrição do pastor auxiliar.',
  },
  {
    name: 'Ricardo',
    role: 'Pastor Auxiliar',
    photo: null,
    // description: 'Descrição do pastor auxiliar.',
  },
];

const Photo = ({ src, alt, ring, glow, size = 'md' }) => {
  const dim = size === 'lg' ? 'w-32 h-32' : 'w-24 h-24';
  return (
    <div className={`relative ${dim} mx-auto flex-shrink-0`}>
      <div className={`absolute -inset-2 ${glow} rounded-full blur-xl`} />
      {src ? (
        <img
          src={src}
          alt={alt}
          className={`relative w-full h-full rounded-full object-cover object-top ring-2 ${ring}`}
        />
      ) : (
        <div className={`relative w-full h-full rounded-full ring-2 ${ring} bg-white/5 flex items-center justify-center`}>
          <FontAwesomeIcon icon={faUser} className="text-gray-600 text-3xl" />
        </div>
      )}
    </div>
  );
};

const Leadership = () => {
  return (
    <section id="lideranca" className="py-24 bg-[#0a0f1e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Cabeçalho */}
        <div className="text-center mb-16">
          <div className="section-label mx-auto w-fit">
            <FontAwesomeIcon icon={faUsers} className="text-xs" /> Equipe Pastoral
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">
            Nossa <span className="text-gradient">Liderança</span>
          </h2>
          <p className="text-gray-500 mt-3 max-w-xl mx-auto">
            Fazemos parte de um movimento global liderado por pastores comprometidos com o Evangelho e com as pessoas.
          </p>
        </div>

        {/* Cadeia de liderança */}
        <div className="flex flex-col md:flex-row items-stretch justify-center gap-0 mb-20">
          {chain.map(({ name, role, org, photo, description, badge, ring, glow, badgeColor, nameColor }, i) => (
            <div key={role} className="flex flex-col md:flex-row items-center">

              {/* Card */}
              <div className="glass-card card-shine rounded-2xl p-6 border border-white/8 flex flex-col items-center text-center w-full md:w-56 hover:bg-white/5 transition-all duration-300 hover:-translate-y-1 h-full">
                <Photo src={photo} alt={name} ring={ring} glow={glow} size="lg" />
                <div className="mt-5 flex flex-col items-center flex-grow">
                  <span className={`inline-block text-xs font-bold uppercase tracking-widest border rounded-full px-3 py-0.5 mb-3 ${badgeColor}`}>
                    {badge}
                  </span>
                  <h3 className={`font-extrabold text-base leading-tight mb-0.5 ${nameColor}`}>{name}</h3>
                  <p className="text-gray-400 text-xs font-semibold mb-0.5">{role}</p>
                  <p className="text-gray-600 text-xs mb-3">{org}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{description}</p>
                </div>
              </div>

              {/* Conector */}
              {i < chain.length - 1 && (
                <>
                  {/* Desktop: seta horizontal */}
                  <div className="hidden md:flex items-center px-3 text-gray-700">
                    <FontAwesomeIcon icon={faChevronRight} className="text-sm" />
                  </div>
                  {/* Mobile: seta vertical */}
                  <div className="flex md:hidden flex-col items-center py-2 text-gray-700">
                    <div className="w-px h-4 bg-white/10" />
                    <div className="text-xs text-gray-700">↓</div>
                    <div className="w-px h-4 bg-white/10" />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        {/* Pastores auxiliares */}
        <div>
          <h3 className="text-center text-xl font-bold text-white mb-2">
            Pastores <span className="text-gradient">Auxiliares</span>
          </h3>
          <p className="text-center text-gray-600 text-sm mb-10">
            Lagoinha Cidade Verde
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {auxiliares.map(({ name, role, photo, description }, i) => (
              <div
                key={i}
                className="glass-card card-shine rounded-2xl p-6 border border-white/8 flex flex-col sm:flex-row gap-5 items-center sm:items-start hover:bg-white/5 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex-shrink-0">
                  <div className="relative w-20 h-20">
                    <div className="absolute -inset-2 bg-white/5 rounded-full blur-lg" />
                    {photo ? (
                      <img
                        src={photo}
                        alt={name}
                        className="relative w-full h-full rounded-full object-cover object-top ring-2 ring-white/15"
                      />
                    ) : (
                      <div className="relative w-full h-full rounded-full ring-2 ring-white/10 bg-white/5 flex items-center justify-center">
                        <FontAwesomeIcon icon={faUser} className="text-gray-600 text-2xl" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-center sm:text-left">
                  <span className="inline-block text-xs font-bold uppercase tracking-widest border rounded-full px-3 py-0.5 mb-2 bg-white/5 text-gray-400 border-white/15">
                    Auxiliar
                  </span>
                  <h4 className="text-white font-bold text-base leading-tight">{name}</h4>
                  <p className="text-gray-500 text-xs mt-0.5 mb-2">{role}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Apps da Lagoinha Global */}
        <div className="mt-20 glass-card rounded-2xl p-8 md:p-12 border border-white/8 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <div className="section-label mb-4 w-fit mx-auto md:mx-0">Lagoinha Global</div>
            <h3 className="text-2xl font-extrabold text-white mb-3">
              Baixe o <span className="text-gradient">App</span>
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed max-w-sm mx-auto md:mx-0">
              Acesse conteúdos, mensagens e devocional da Lagoinha Global direto no seu celular.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://apps.apple.com/br/app/lagoinha-global/id1672140110"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 text-white px-6 py-4 rounded-xl transition-all duration-200 hover:-translate-y-0.5 min-w-[160px]"
            >
              <FontAwesomeIcon icon={faApple} className="text-2xl" />
              <div className="text-left">
                <div className="text-gray-400 text-[10px] leading-none mb-0.5">Disponível na</div>
                <div className="font-bold text-sm leading-none">App Store</div>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.inpeaceapp.lagoinhaglobal.sp"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 text-white px-6 py-4 rounded-xl transition-all duration-200 hover:-translate-y-0.5 min-w-[160px]"
            >
              <FontAwesomeIcon icon={faGooglePlay} className="text-2xl text-green-400" />
              <div className="text-left">
                <div className="text-gray-400 text-[10px] leading-none mb-0.5">Disponível no</div>
                <div className="font-bold text-sm leading-none">Google Play</div>
              </div>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Leadership;
